import ApiService from '@/services/ApiService';
import store from '@/store';

export enum PermissionType {
  ADMIN = 'admin',
  WAB = 'wab',
}

function getRoles() {
  return ApiService.post('/parse/functions/getRoles', {}).then((res) => res.result);
}

function isAdmin() {
  return store.state.roles.roles.admin;
}

function isWABEnabled() {
  return store.state.retailer.retailer.account && (store.state.retailer.retailer.account as any).wab &&
    (store.state.retailer.retailer.account as any).wab.enabled;
}

function checkPermissions(permissions: PermissionType[]) {
  for (const p of permissions) {
    if (p === PermissionType.ADMIN) {
      if (!isAdmin()) {
        return false;
      }
    } else if (p === PermissionType.WAB) {
      if (!isWABEnabled()) {
        return false;
      }
    }
  }
  return true;
}

async function isIntegrationEnabled(platform: string) {
  let integrations = store.state.integration.integrations;
  if (!integrations || !integrations.length) {
    integrations = await store.dispatch('loadIntegrations');
  }
  const found = integrations.find((int: any) => int.platform === platform);
  return found && found.status === 'READY';
}

const PermissionService = {
  getRoles,
  isAdmin,
  isWABEnabled,
  checkPermissions,
  isIntegrationEnabled,
};

export default PermissionService;
